import { useEffect, useRef, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import UnleashLoadingError from '../../UnleashLoadingError';

export const useUnleashLoading = () => {
  const [loading, setLoading] = useState(true);
  const hasBeenReadyRef = useRef(false);
  const hasReportedErrorRef = useRef(false);
  const { flagsReady, flagsError } = useFlagsStatus();

  useEffect(() => {
    if (flagsReady) {
      hasBeenReadyRef.current = true;
    }
    if (flagsReady || flagsError) {
      if (flagsError && !hasBeenReadyRef.current && !hasReportedErrorRef.current) {
        hasReportedErrorRef.current = true;
        datadogRum.addError(new UnleashLoadingError(flagsError));
      }
      setLoading(false);
    }
  }, [flagsReady, flagsError]);

  return loading;
};